export default {
  "brand.name": "AllChinaBuy Spreadsheet",
  "brand.tagline": "Produktrecherche & QC",

  "nav.home": "Startseite",
  "nav.shoppingGuide": "Einkaufsführer",
  "nav.categories": "Kategorien",
  "nav.qc": "QC-Fotos",
  "nav.shipping": "Versand",
  "nav.review": "Bewertung",
  "nav.safety": "Sicherheit",
  "nav.buyNow": "Jetzt kaufen",

  "lang.en": "English",
  "lang.fr": "Français",
  "lang.da": "Dansk",
  "lang.de": "Deutsch",

  "hero.badge": "Unabhängige Ressource · Aktualisiert 2026",
  "hero.title": "AllChinaBuy Spreadsheet — Produkte, QC-Fotos und bessere Kaufratgeber finden",
  "hero.subtitle": "Entdecken Sie AllChinaBuy-Spreadsheets, Produktfunde, QC-Informationen, Versand-Guides, Lagertipps, Gutscheine und Sicherheitsressourcen an einem übersichtlichen Ort.",
  "hero.ctaExplore": "AllChinaBuy Spreadsheet",
  "hero.ctaBuyNow": "Jetzt kaufen",
  "hero.searchPlaceholder": "AllChinaBuy-Spreadsheets, Produkte, QC oder Versand durchsuchen...",
  "hero.dropdownLabel": "Produktkategorien durchsuchen",
  "hero.noResults": "Keine Kategorien gefunden",

  "categories.title": "Beliebte Produktkategorien",
  "categories.subtitle": "Springen Sie direkt zu einer beliebigen Produktkategorie auf der Hauptseite AllChinaBuy Spreadsheet.",
  "categories.shoes": "Schuhe",
  "categories.hoodies": "Hoodies / Sweatshirts",
  "categories.tshirts": "T-Shirts",
  "categories.jackets": "Jacken",
  "categories.pants": "Hosen / Shorts",
  "categories.headwear": "Kopfbedeckungen",
  "categories.sets": "Sets",
  "categories.underwear": "Unterwäsche / Unterhosen",
  "categories.jersey": "Trikots",
  "categories.accessories": "Accessoires",
  "categories.bags": "Taschen",
  "categories.belts": "Gürtel",
  "categories.perfumes": "Parfums",
  "categories.other": "Sonstiges",

  "what.title": "Was ist ein AllChinaBuy Spreadsheet?",
  "what.body": "Ein AllChinaBuy-Spreadsheet ist eine geteilte, übersichtliche Tabelle, die Produktlinks, Preise, Größen, QC-Fotos und Versandnotizen für die Artikel sammelt, die Sie über AllChinaBuy kaufen möchten. Statt Dutzende Browser-Tabs offen zu halten, behalten Sie alles an einem Ort — das macht Recherche, Bestellung und Qualitätskontrolle deutlich einfacher.",

  "qc.title": "QC-Fotos & Qualitätsratgeber",
  "qc.body": "Qualitätskontrollfotos ermöglichen es Ihnen, einen Artikel vor dem Versand zu prüfen. Eine gute Tabelle erfasst QC-Fotolinks, Maße und eventuelle Mängel, damit Sie bestätigen können, dass das Produkt der Anzeige entspricht, bevor Sie für den internationalen Versand bezahlen.",

  "shipping.title": "AllChinaBuy Versandkosten-Ratgeber",
  "shipping.body": "Die Versandkosten hängen vom Gewicht, Volumen und der gewählten Versandlinie ab. Eine gut strukturierte Tabelle erfasst das geschätzte Gewicht, die Linienoptionen und die Endkosten für jeden Haul und hilft Ihnen, ein Budget zu planen und die günstigste Route in Ihr Land zu wählen.",

  "review.title": "AllChinaBuy Bewertung & Vertrauen",
  "review.body": "Wir fassen echte Erfahrungen, Vor- und Nachteile, Lieferzeiten und die Qualität des Supports zusammen. Prüfen Sie vor Entscheidungen stets die aktuellen Bedingungen und Richtlinien auf der offiziellen AllChinaBuy-Plattform.",

  "safety.title": "Sicherheitscenter",
  "safety.body": "Vermeiden Sie gefälschte Tabellen und verdächtige Links. Nutzen Sie nur vertrauenswürdige Quellen, prüfen Sie Verkäufer, verstehen Sie Zoll- und Steuerregeln und geben Sie Zahlungsdaten niemals außerhalb offizieller Kanäle weiter.",

  "articles.title": "Neueste Guides & Artikel",
  "articles.subtitle": "Originale, ausführliche SEO-Guides rund um das AllChinaBuy-Spreadsheet-Thema.",
  "articles.card.title": "AllChinaBuy Spreadsheet: Der komplette Guide 2026",
  "articles.card.excerpt": "Erfahren Sie, was ein AllChinaBuy-Spreadsheet ist, wie Sie ihn für Produktrecherche und QC nutzen, was der Versand wirklich kostet und ob AllChinaBuy sicher und seriös ist.",
  "articles.card.readMore": "Guide lesen",
  "articles.card.meta": "Guide · 8 Min. Lesezeit",

  "faq.title": "Häufig gestellte Fragen",
  "faq.q1": "Ist AllChinaBuy seriös?",
  "faq.a1": "AllChinaBuy ist ein bekannter Einkaufsagent. Nutzen Sie stets die offizielle Website und prüfen Sie die Richtlinien, bevor Sie bestellen. Diese unabhängige Seite ist nicht die offizielle Plattform.",
  "faq.q2": "Wie viel kostet der AllChinaBuy-Versand?",
  "faq.a2": "Die Kosten hängen von Gewicht, Volumen und gewählter Linie ab. Leichtere, kleinere Pakete und Economy-Linien sind in der Regel günstiger.",
  "faq.q3": "Was ist ein AllChinaBuy-Spreadsheet?",
  "faq.a3": "Es ist eine geteilte Tabelle, die Produktlinks, Preise, QC-Fotos und Versandnotizen für die Artikel Ihres Hauls organisiert.",
  "faq.q4": "Bietet AllChinaBuy QC-Fotos an?",
  "faq.a4": "Ja, QC-Fotos sind für viele Bestellungen verfügbar, damit Sie Artikel vor dem internationalen Versand prüfen können.",
  "faq.q5": "Wie finde ich AllChinaBuy-Gutscheine oder Rabattcodes?",
  "faq.a5": "Prüfen Sie die offizielle Website und vertrauenswürdige Communities auf aktuelle Angebote. Wir veröffentlichen keine ungeprüften Gutscheine oder Aktionen.",

  "final.title": "Bereit, das AllChinaBuy Spreadsheet zu erkunden?",
  "final.subtitle": "Öffnen Sie die vollständige Tabelle, um Produkte zu durchsuchen, QC-Fotos zu prüfen und Ihren nächsten Haul zu planen.",
  "final.button": "AllChinaBuy Spreadsheet öffnen",

  "footer.disclaimer": "AllChinaBuySpread.uk ist eine unabhängige Informationsquelle und nicht die offizielle AllChinaBuy-Website. Informationen können sich ändern. Prüfen Sie vor Entscheidungen aktuelle Preise, Aktionen, Versandregeln und Richtlinien.",
  "footer.rights": "Alle Rechte vorbehalten.",
  "footer.guide": "Spreadsheet-Guide",
  "footer.home": "Startseite",
}